import { useState } from 'react'

export interface IUseOpenClose {
  defaultIsOpen?: boolean
}

export const useOpenClose = ({ defaultIsOpen }: IUseOpenClose) => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen)

  return {
    isOpen,
    onClose: () => setIsOpen(false),
    onOpen: () => setIsOpen(true),
    onToggle: () => setIsOpen((prev) => !prev),
  }
}
